export default "__VITE_ASSET__DA0Djxx1__"